import axios from 'axios';
import {API} from "@/services/url";

export default {
	getResellerList : function (success, error) {
		axios.get(API.reseller.all)
			.then(r => success(r.data.resellerList))
			.catch(e => error(e.response.data.message));
	},

	getResellerDetails : function (resellerId, success, error){
		axios.get(API.reseller.all + resellerId)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},

	getResellerStockByProjectId : function (projectId, success, error){
		axios.get(API.reseller.stock + projectId)
			.then(r => success(r.data.resellerStock))
			.catch(e => error(e.response.data.message));
	}
}
